// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IReviewRateFilter } from './ReviewRateFilter';

export interface IGetReviewsWebRequest {
  /** id ЖК **/
  newbuildingId: number;
  /** Фильтры **/
  filters?: TGetReviewsWebRequest_Filters;
  /** Пагинация **/
  page?: TGetReviewsWebRequest_Page;
  /** Загрузить все отзывы **/
  getAllItems?: TGetReviewsWebRequest_GetAllItems;
  /** Фильтр по тегу **/
  tag?: TGetReviewsWebRequest_Tag;
  /** Сортировка **/
  sort?: TGetReviewsWebRequest_Sort;
}

export type TGetReviewsWebRequest_Filters = null | TGetReviewsWebRequest_Filters_1;

export type TGetReviewsWebRequest_Filters_1 = IReviewRateFilter[];

export type TGetReviewsWebRequest_Page = null | number;

export type TGetReviewsWebRequest_GetAllItems = null | boolean;

export type TGetReviewsWebRequest_Tag = null | ETag;

export enum ETag {
  /** Инфраструктура **/
  'Infrastructure' = 'infrastructure',
  /** Придомовая территория **/
  'Adjoining_territory' = 'adjoining_territory',
  /** Транспортная доступность **/
  'Transport_affordable' = 'transport_affordable',
  /** Дом **/
  'House' = 'house',
  /** Парковка **/
  'Parking' = 'parking',
  /** Отделка **/
  'Flat' = 'flat',
  /** Дети **/
  'Kids' = 'kids',
  /** Строительство **/
  'Construction' = 'construction',
  /** Покупка **/
  'Purchase' = 'purchase',
  /** Район **/
  'District' = 'district',
  /** управляющая компания **/
  'Management_company' = 'management_company',
  /** Застройщик **/
  'Developer' = 'developer',
}
export type TGetReviewsWebRequest_Sort = null | ESort;

export enum ESort {
  /** По умолчанию **/
  'Default' = 'default',
  /** По дате (сначала новые) **/
  'By_date_asc' = 'by_date_asc',
  /** По дате (сначала старые) **/
  'By_date_desc' = 'by_date_desc',
  /** По оценке (сначала низкая) **/
  'By_rating_asc' = 'by_rating_asc',
  /** По оценке (сначала высокая) **/
  'By_rating_desc' = 'by_rating_desc',
}
